var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChocolateBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5815 2H14.75V6.25H18V5.24537C16.9391 4.39492 16.0995 3.27973 15.5815 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2H10.25V6.25H13.25V2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 7.75H10.25V12.25H13.25V7.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 7.75V12.25H6V7.75H8.75Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13.75H6V16.4385C6.21074 16.6936 6.4769 16.9624 6.77887 17.1822C7.29473 17.5577 7.81641 17.7239 8.3181 17.5985C8.47607 17.559 8.61902 17.5138 8.75 17.4635V13.75Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 13.75H10.25V16.3828C10.2744 16.36 10.2996 16.3366 10.3257 16.3125C10.5405 16.1142 10.7862 15.9006 11.084 15.7021C11.5258 15.4075 12.3389 15.1295 13.25 15.3049V13.75Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 13.75H18V16.8808C17.422 17.3224 17.0189 17.4167 16.7204 17.3913C16.2782 17.3537 15.7749 17.0404 15.0303 16.2958C14.9375 16.203 14.844 16.1176 14.75 16.039V13.75Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.75V12.25H14.75V7.75H18Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.25V2H7C6.44772 2 6 2.44772 6 3V6.25H8.75Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21V18.4685C6.69939 18.9496 7.63627 19.3151 8.6819 19.0537C9.62169 18.8188 10.224 18.4175 10.7149 17.994C10.8691 17.861 11.0253 17.7135 11.1654 17.5813C11.2285 17.5217 11.2883 17.4653 11.3431 17.4147C11.5345 17.238 11.7138 17.085 11.916 16.9501C12.1943 16.7646 13.0818 16.4685 13.9697 17.3564C14.7251 18.1118 15.5661 18.7985 16.5932 18.8859C17.0716 18.9266 17.5372 18.8352 18 18.6274V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChocolateBar);
export default __webpack_public_path__ + "static/media/chocolate-bar.db5917e0440c916f00b08ec090f178ad.svg";
export { ForwardRef as ReactComponent };